export default "__VITE_ASSET__BUWRuToX__"